import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { UploadActions, UploadActionTypes } from '@actions/upload.action';
import { UploadItem } from '@common/entities/uploads/upload-item.entity';

import { UploadState } from 'state';

export const uploadAdapter: EntityAdapter<UploadItem> = createEntityAdapter<UploadItem>({
    selectId: uploadItem => uploadItem.tempId
});

export const initialState: UploadState = uploadAdapter.getInitialState();

export function uploadReducer(state = initialState, action: Action): UploadState {
    const uploadAction: UploadActions = action as UploadActions;

    switch (uploadAction.type) {
        case UploadActionTypes.Add:
            return uploadAdapter.addOne(uploadAction.uploadItem, state);

        case UploadActionTypes.Remove:
            return uploadAdapter.removeOne(uploadAction.id, state);

        case UploadActionTypes.Update:
            return uploadAdapter.updateOne({ id: uploadAction.id, changes: uploadAction.changes }, state);

        default:
            return state;
    }
}
